import { render, staticRenderFns } from "./DropdownSubMenu.vue?vue&type=template&id=ca149314&scoped=true&"
import script from "./DropdownSubMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownSubMenu.vue?vue&type=style&index=0&id=ca149314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca149314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca149314')) {
      api.createRecord('ca149314', component.options)
    } else {
      api.reload('ca149314', component.options)
    }
    module.hot.accept("./DropdownSubMenu.vue?vue&type=template&id=ca149314&scoped=true&", function () {
      api.rerender('ca149314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/dropdown/DropdownSubMenu.vue"
export default component.exports